var RewardAmountType;
(function (RewardAmountType) {
    RewardAmountType["Fixed"] = "fixed";
    RewardAmountType["Percent"] = "percent";
    RewardAmountType["Count"] = "count";
})(RewardAmountType || (RewardAmountType = {}));

export { RewardAmountType };
//# sourceMappingURL=RewardAmountType.js.map
